<template>
	<div>
		<Breadcrumbs main="Support Management" title="Access Logs" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-12">
					<a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end mb-3">
						<i class="bx bx-chevrons-left"></i> Back
					</a>
				</div>
			</div>

			<div class="card mb-4" v-if="requester">
				<div class="card-body">
					<h5 class="card-title">Requester Information</h5>
					<div class="row">
						<div class="col-md-4"><strong>Name:</strong> {{ requester.name || '-' }}</div>
						<div class="col-md-4"><strong>Mobile:</strong> {{ requester.phone || '-' }}</div>
					</div>
				</div>
			</div>

			<div class="card">
				<div class="card-body">
					<div class="col-md-12 project-list filter-sort">
						<div class="row">
							<div class="col-md-4 d-flex mt-2">
								<label class="d-flex listing-length ms-1"><span>Show</span>
									<select class="form-select" v-model="listing_length" @change="fetchLogs()">
										<option value="10">10</option>
										<option value="20">20</option>
										<option value="50">50</option>
									</select>
									<span>entries</span>
								</label>
							</div>
						</div>
					</div>

					<div class="table-responsive product-table">
						<table class="display">
							<thead>
								<tr align="center">
									<th>Sl.No</th>
									<th>Date</th>
									<th>IP Address</th>
									<th>Location</th>
									<th>Keyword</th>
									<th>IMEI</th>
									<th>Vehicle No</th>
									<th>Status</th>
								</tr>
							</thead>
							<tbody v-if="Boolean(logs.length)">
								<tr v-for="(item, index) in logs" :key="item.id" align="center">
									<td>{{ from + index }}</td>
									<td>{{ item.created_at ? $filters.formatDateTime(item.created_at) : '-' }}</td>
									<td>{{ item.ip_address || '-' }}</td>
									<td>{{ item.location || '-' }}</td>
									<td>{{ item.keyword || '-' }}</td>
									<td>{{ item.imei || '-' }}</td>
									<td>{{ item.vehicle_number || '-' }}</td>
									<td>
										<span class="badge rounded-pill bg-success" v-if="item.status === 'success'">Success</span>
										<span class="badge rounded-pill bg-danger" v-else>{{ item.error || item.status || 'Failed' }}</span>
									</td>
								</tr>
							</tbody>
							<tbody v-else>
								<tr>
									<td colspan="8" align="center">No access logs found</td>
								</tr>
							</tbody>
						</table>
					</div>

					<caption v-if="Boolean(logs.length)" class="float-start mt-2 d-block d-lg-inline">Showing {{ from }} to {{ to }} of {{ total }} entries</caption>
					<nav aria-label="Page navigation" class="mt-2 float-end">
						<ul class="pagination">
							<li
								class="page-item"
								v-bind:class="[{ disabled: !page.url }, { active: page.active }]"
								v-for="(page, index) in pagination"
								:key="page.label"
							>
								<a class="page-link" href="#" @click.prevent="fetchLogs(buildQueryString(page.url))" tabindex="-1">
									<span v-if="index == 0">Prev</span>
									<span v-else-if="index == pagination.length - 1">Next</span>
									<span v-else>{{ page.label }}</span>
								</a>
							</li>
						</ul>
					</nav>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ApiRequesterLogs',
	data() {
		return {
			token: '',
			requester: null,
			logs: [],
			pagination: [],
			listing_length: 10,
			from: 0,
			to: 0,
			total: 0,
		};
	},
	mounted() {
		this.fetchLogs();
	},
	methods: {
		getToken() {
			if (localStorage.getItem('airotrack_staff')) {
				const airotrack_staff = JSON.parse(localStorage.getItem('airotrack_staff'));
				if (airotrack_staff.token) {
					this.token = airotrack_staff.token;
				} else {
					this.$swal('', 'Failed to fetch token, please login again', 'error');
					this.$router.push({ name: 'login' });
				}
			} else {
				this.$swal('', 'Session expired, please login again', 'error');
				this.$router.push({ name: 'login' });
			}
		},
		buildQueryString(baseUrl = null) {
			const params = new URLSearchParams();
			params.append('limit', this.listing_length);
			params.append('requester_id', this.$route.params.id);
			if (baseUrl) {
				const separator = baseUrl.includes('?') ? '&' : '?';
				return baseUrl + separator + params.toString();
			}
			return '/staffs/apiRequesterLogs?' + params.toString();
		},
		fetchLogs(page_url = null) {
			this.getToken();
			page_url = page_url || this.buildQueryString();
			this.$axios
				.get(page_url, { headers: { Authorization: 'Bearer ' + this.token } })
				.then((res) => {
					const responseData = res.data.data || {};
					this.requester = responseData.requester || null;
					const page = responseData.logs || {};
					this.logs = page.data || [];
					this.pagination = page.links || [];
					this.from = page.from || 0;
					this.to = page.to || 0;
					this.total = page.total || 0;
				})
				.catch((err) => {
					this.$swal('Error', this.$getApiErrorMessage?.(err, 'Failed to load access logs') || 'Failed to load access logs', 'error');
				});
		},
	},
};
</script>

<style>
@import '@/assets/css/custom.css';
</style>
